export default __webpack_public_path__ + "static/media/mxnet_logo.a6a773c3.png";